import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType, FileType } from "@/common/types/common";
import type { SamplePayloadType, SampleType } from "@/common/types/sample";

export async function sampleList(account_id: string, query?: QueryType) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/sample/list${queryString}`,
  );
}

export async function sampleAdd(
  account_id: string,
  payload: SamplePayloadType,
) {
  return await clientAxios.post(`account/${account_id}/sample/create`, payload);
}

export async function sampleGet(account_id: string, samples_id: string) {
  return await clientAxios.get(
    `account/${account_id}/sample/${samples_id}/show`,
  );
}

export async function samplePut(
  account_id: string,
  samples_id: string,
  payload: SamplePayloadType,
) {
  return await clientAxios.put(
    `account/${account_id}/sample/${samples_id}/edit`,
    payload,
  );
}

export async function samplePatch(
  account_id: string,
  samples_id: string,
  payload: Partial<SampleType>,
) {
  return await clientAxios.patch(
    `account/${account_id}/sample/${samples_id}/patch`,
    {
      payload,
    },
  );
}

export async function sampleDel(account_id: string, samples_id: string) {
  return await clientAxios.del(
    `account/${account_id}/sample/${samples_id}/delete`,
  );
}

export async function sampleUpload(account_id: string, payload: FileType) {
  return await clientAxios.post(`account/${account_id}/sample/upload`, payload);
}

export async function sampleModelCSV(account_id: string) {
  return await clientAxios.get(`account/${account_id}/sample/csv/model`);
}
